<template>
  <v-card
    flat
    tile
  >
    <v-card-text>
      <v-row v-show="!enableForm">
        <v-col
          v-for="result in results"
          :key="`template--${result.id}`"
          cols="12"
          sm="4"
          md="3"
          lg="2"
        >
          <v-card
            class="mx-auto"
            flat
            outlined
          >
            <v-card-text
              style="cursor: pointer"
              @click="openForm(result.id)"
            >
              <v-row no-gutters>
                <v-col class="text-h5">
                  {{ result.name }}
                </v-col>
                <v-col cols="auto">
                  <contactless-options
                    :account-id="accountId"
                    :contactless-id="result.id"
                    @reload="get()"
                  />
                </v-col>
              </v-row>
            </v-card-text>
          </v-card>
        </v-col>
        <v-col
          key="template--new"
          cols="12"
          sm="4"
          md="3"
          xl="2"
          class="d-flex"
        >
          <v-card
            class="mx-auto"
            flat
            outlined
          >
            <v-card-text
              style="cursor: pointer"
              @click="openForm()"
            >
              <v-row
                class="text-center"
                no-gutters
              >
                <v-col
                  cols="12"
                  class="text-h5"
                >
                  <v-icon>mdi-plus</v-icon> Theme
                </v-col>
              </v-row>
            </v-card-text>
          </v-card>
        </v-col>
      </v-row>
    
      <v-row>
        <v-col cols="12">
          <contactless-form
            v-if="enableForm"
            :id="selectedId"
            :enable.sync="enableForm"
          />
        </v-col>
      </v-row>
    </v-card-text>
  </v-card>
</template>

<script>
import { failure } from "@/mixins/common";
import ContactlessForm from "./ContactlessFrom.vue";
import ContactlessOptions from "./ContactlessOptions.vue";
export default {
  name: "Contactless",
  components: {
    ContactlessForm,
    ContactlessOptions
  },
  mixins: [failure],
  data() {
    return {
      loader: false,
      accountId: parseInt(this.$route.params.accountId),
      enableForm: false,
      selectedId: null,
      results: []
      // enableDialog: false
    };
  },
  created() {
    this.get();
  },
  methods: {
    get() {
      this.loader = true;
      let url = `${this.ADMIN_API_URL}/accounts/${this.accountId}/contactless`;
      this.$http.get(url).then(
        (res) => {
          this.results = res.body || [];
          this.loader = false;
        },
        (failure) => {
          this.loader = false;
          this.handleFailure(failure);
        }
      );
    },
    openForm(themeId = null) { 
    
      this.selectedId = themeId;
      this.enableForm = true;
      // this.enableDialog = false;
    }
  }
};
</script>
